import React from 'react'
import _ from 'lodash'
import { FaCircle, FaCompressArrowsAlt, FaExpandArrowsAlt, FaGripLines } from 'react-icons/fa'
import classNames from 'classnames'
import moment from 'moment'

import Button from 'components/Button'
import desktop from 'assets/desktop.png'


export default function LayoutPlayer(props) {
  const [fullplayer, setFullplayer] = React.useState(false)
  const [fullScreen, setFullScreen] = React.useState(false)
  const [_currentHandler, setHandlerResizer] = React.useState(null)
  const [_currentVideoContainer, setVideoContainer] = React.useState(null)
  const startY = React.useRef(null)
  const startHeight = React.useRef(null)
  const startWidth = React.useRef(null)
  const currentVideo = React.useRef(null)

  React.useEffect(() => {
    if (_currentHandler) {
      _currentHandler.addEventListener('pointerdown', initDrag, false)
      document.documentElement.addEventListener('pointerup', stopDrag, false)
    }

    return () => {
      if (_currentHandler) {
        _currentHandler.removeEventListener('pointerdown', () => {}, false)
        document.documentElement.removeEventListener('pointerup', () => {}, false)
      }
    }
  }, [_currentHandler]) // eslint-disable-line react-hooks/exhaustive-deps

  React.useEffect(() => {
    if (_currentVideoContainer) {
      _currentVideoContainer.style.height = fullScreen ? 'calc(100vh - 56px)' : '70vh'
    }
  }, [fullScreen]) // eslint-disable-line react-hooks/exhaustive-deps

  const initDrag = (e) => {
    e.preventDefault()
    e.stopPropagation()
    document.documentElement.addEventListener('pointermove', doDrag, false)
    window.addEventListener('pointermove', function (e) { e.preventDefault() }, false)
    startY.current = e.clientY
    startHeight.current = parseInt(document.defaultView.getComputedStyle(_currentVideoContainer).height, 10)
    startWidth.current = parseInt(document.defaultView.getComputedStyle(_currentVideoContainer).width, 10)
  }

  const stopDrag = (e) => {
    e.preventDefault()
    e.stopPropagation()
    document.documentElement.removeEventListener('pointermove', doDrag, false)
  }

  const handlerResizerCallback = React.useCallback(
    (node) => {
      setHandlerResizer(node)
    },
    [],
  )

  const doDrag = (e) => {
    e.preventDefault()

    const containerHeight = (startHeight.current + e.clientY - startY.current)

    _currentVideoContainer.style.height = containerHeight + 'px'
  }

  const videoContainerCallback = React.useCallback(
    (node) => {
      setVideoContainer(node)
    },
    [],
  )

  const currentFile = props.actions?.file
  const countSameFile = props.actions?.countSameFile
  React.useEffect(() => {
    if (
      currentVideo.current &&
      currentFile?.type === 'Video'
    ) {
      currentVideo.current.currentTime = 0
    }
  }, [countSameFile, currentFile])

  return (
    <div className='flex flex-col flex-grow-0 relative'>
      <div className='relative w-full h-full'>
        <div
          className='flex justify-center items-center flex-grow overflow-hidden p-5'
          ref={videoContainerCallback}
          style={{
            maxHeight: 'calc(100vh - 54px)',
            minHeight: '20vh',
            height: '50vh',
          }}
        >
          <div className={classNames([
            'flex relative h-full rounded-2xl overflow-hidden',
            {
              'w-full bg-disabled-200': fullplayer,
            }
          ])}>
            <img
              src={desktop}
              alt='placeholder'
              className='object-contain max-w-full max-h-full m-auto bg-disabled-200'
            />
            {
              _.map(
                [...(props.actions?.audios || []), ...(_.filter(props.actions?.files, {type: 'Video'}) || [])],
                file => (
                  <audio key={`audio_${file.id}`} loop autoPlay src={file.blob} />
                )
              )
            }
            {
              currentFile && (
                currentFile.type === 'Image' ?
                <img
                  key={`img_${currentFile.id}`}
                  src={currentFile.blob || currentFile.medium || currentFile.currentFile}
                  dragable='true'
                  className='absolute left-0 right-0 bottom-0 top-0 w-full h-full object-cover'
                  alt={currentFile.title}
                /> :
                <video
                  key={`video_${currentFile.id}`}
                  muted
                  ref={currentVideo}
                  disableRemotePlayback
                  alt={currentFile.title}
                  src={currentFile.blob || currentFile.medium || currentFile.file}
                  dragable='true'
                  autoPlay
                  loop
                  className='absolute left-0 right-0 bottom-0 top-0 w-full h-full object-cover'
                />
              )
            }
          </div>
        </div>
        <Button
          onClick={() => setFullScreen(!fullScreen)}
          className='hidden lg:block p-6 fill absolute right-4 bottom-4 rounded-full text-white'
          theme='disabled'
        >
          {
            fullScreen ?
              <FaCompressArrowsAlt /> :
              <FaExpandArrowsAlt />
          }
        </Button>
      </div>
      <div className='flex-grow flex flex-1 items-center shadow-lg z-30 bg-white'>
        <nav className='flex justify-start flex-grow' id='menu-resize'>
          <Button
            onClick={() => setFullplayer(!fullplayer)}
            className='p-6'
          >
            {
              fullplayer ?
                <FaCompressArrowsAlt /> :
                <FaExpandArrowsAlt />
            }
          </Button>
        </nav>
        <div className='time justify-end flex flex-grow'>{moment(props.time).format("mm:ss")}</div>
        <nav className='justify-center flex flex-grow h-full'>
          <Button
            onClick={() => props.setRec( ! props.rec)}
            className='group flex h-full w-16 items-center justify-center relative'
          >
            <FaCircle className={classNames([
              'text-red-500',
              'absolute',
              {
                'animate-ping': props.rec,
              }
            ])} />
            <FaCircle className='
              text-red-500
              group-hover:text-red-800
              transition-all
            ' />
          </Button>
        </nav>
        <div className='hidden sm:flex justify-end flex-grow' />
        <nav className='justify-end flex flex-grow' ref={handlerResizerCallback}>
          <Button
            onClick={() => { }}
            className='cursor-move pointer-events-auto p-6'
          >
            <FaGripLines />
          </Button>
        </nav>
      </div>
    </div>
  )
}
